module.exports = __webpack_public_path__ + "static/media/shirt.75bd0137.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/review/shirt.png
// module id = 678
// module chunks = 0